// @core/api/endpoints/landing/update_landing_page.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LandingPageResponse,
  UpdateLandingPageRequest,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Update landing page
 * Updates page properties: title, description, slug, settings, theme, and sections.
 */
export async function UpdateLandingPage(
  page_id: string,
  data: UpdateLandingPageRequest,
  options?: RequestOptions
): Promise<LandingPageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/pages/:page_id`;
  requestPath = requestPath.replace(':page_id', encodeURIComponent(page_id));
  const requestOptions = options;
  return client.put<LandingPageResponse>(requestPath, data, requestOptions);
}
